import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { WidgetsContextProvider } from "@stores/widgets-context";
import DefaultPage from "@pages/default-page";
import NotFound from "@widgets/not-found";

const DynamicRoutes = () => {
    const routes = window.Spa.routes;
    if (!routes) return;
    return (
        <Routes>
            {routes.map((route, index) => (
                <Route
                    key={index}
                    path={route.path}
                    element={
                        !route.pageType || route.pageType === "DefaultPage" ? (
                            <DefaultPage
                                path={route.pageApiUrl}
                                requestMethod={route.requestMethod}
                                requestBodyKey={route.requestBodyKey}
                                loadingScreenVm={route.loadingScreenVm}
                            />
                        ) : null
                    }
                />
            ))}
            <Route path="*" element={<NotFound />}></Route>
        </Routes>
    );
};

const App = () => {
    return (
        <WidgetsContextProvider>
            <BrowserRouter>
                <DynamicRoutes />
            </BrowserRouter>
        </WidgetsContextProvider>
    );
};

export default App;
